// src/ts/app/src/theme/tokens.ts
// Values copied verbatim from theme.tsx — DO NOT change values in this phase.
// Groups that have no explicit overrides in theme.tsx (radius, zIndex, breakpoints)
// are intentionally omitted to avoid inventing design values.

export const tokens = {
  color: {
    /** Page/component backgrounds */
    surface: {
      /** Main app background — APP_BACKGROUND_COLOR */
      base: "#0C111D",
      /** InitialSettings dark background */
      raisedDark: "#151718",
      /** Navbar + footer background — NAVBAR_AND_FOOTER_BACKGROUND_COLOR */
      navbarFooter: "black",
    },
    text: {
      /** Body text — TEXT_COLOR */
      primary: "#BCBEC0",
      /** Skip-button muted text — SKIP_BUTTON_TEXT_COLOR */
      muted: "#889096",
      /** SVG icon fill — SVG_ICON_COLOR */
      icon: "#FFFFFF",
      /** Navbar/footer text — NAVBAR_FOOTER_TEXT_COLOR */
      navbarFooter: "white",
      /** Button label text — BUTTON_TEXT_COLOR */
      button: "white",
    },
    /** Dividers / card borders — BORDER_COLOR */
    border: "#26292B",
    /** Brand accent / primary interactive colour — APP_COLOR */
    accent: "#27B6CB",
    /** Hover state of accent — APP_HOVER_COLOR */
    accentHover: "#1A8899",
    /** Active navbar item — NAVBAR_ACTIVE_TEXT_COLOR (equals APP_COLOR) */
    navbarActive: "#27B6CB",
  },
  /** Spacing function: mirrors MUI's default 8 px base (no override in theme.tsx).
   *  Usage: tokens.space(2) === 16 */
  space: (n: number) => n * 8,
  typography: {
    /** Base font family — FONT_FAMILY */
    family: "Argumentum",
  },
} as const;

export type Tokens = typeof tokens;
